import Swiper from 'swiper'
import { Pagination, Navigation, Mousewheel } from 'swiper/modules'
import {mousewheel} from '@/scripts/core/global'

export function handleBaseSlider() {
	const sliders = document.querySelectorAll(
		'.js-base-slider'
	) as NodeListOf<HTMLElement>

	sliders &&
		sliders.forEach((slider) => {
			const hasSpaceAround = slider.classList.contains('has-outline-space-around');
			const spaceAround = hasSpaceAround ? 1 : 0;
			new Swiper(slider, {
				modules: [Pagination, Navigation, Mousewheel],
				mousewheel,
				slidesPerView: 1.39,
				navigation: {
					prevEl: slider.querySelector(
						'.swiper-button-prev'
					) as HTMLButtonElement,
					nextEl: slider.querySelector(
						'.swiper-button-next'
					) as HTMLButtonElement,
				},
				pagination: {
					el: slider.querySelector(
						'.swiper-pagination'
					) as HTMLElement,
					clickable: true,
				},
				breakpoints: {
					768: {
						slidesPerView: 2.4,
						spaceBetween: spaceAround ? 1 : 0,
					},
					1024: {
						slidesPerView: 4,
						spaceBetween: spaceAround ? 1 : 0,
					},
				},
			})
		})
}
